export default {"src":"/_next/static/media/flux.8e3569b7.svg","height":128,"width":461,"blurWidth":0,"blurHeight":0};